var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAvatarDark = function SvgAvatarDark(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#32363B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#avatarDark_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.966 22.732a3.7 3.7 0 0 1-3.679-3.723 3.7 3.7 0 0 1 3.74-3.661 3.7 3.7 0 0 1 3.678 3.722 3.7 3.7 0 0 1-3.74 3.662Zm8.024-3.698c.1-1.96-.574-5.17-2.227-7.794-.044-.068-.119-.041-.103.03.11.4.137 1.123-.502 1.08-1.131-.075.04-2.486-2.445-4.158-.05-.034-.11.011-.082.064.17.323.272 1.328-.122 1.671-.316.275-.896.201-1.453-.704-.93-1.51-.576-3.123.055-4.13.047-.076-.018-.106-.072-.088-3.418 1.123-4.1 5.134-4.828 6.597-.122.245-.228.373-.436.36-.623-.042-.175-1.365.041-1.825.03-.065-.044-.1-.085-.059-1.76 1.831-3.353 4.949-3.655 7.846.01-.069-.029.24-.047.465a10.045 10.045 0 0 0-.029.585c-.036 4.396 3.514 7.99 7.93 8.026 4.416.036 8.025-3.498 8.062-7.895l-.002-.071Z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "avatarDark_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(8 5)",
    d: "M0 0h16v22H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAvatarDark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/avatarDark.svg";